"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extractFilterFromURL = _interopRequireDefault(require("./extractFilterFromURL"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function translateUrl(path, search, language, props) {
  var pathArray = path.split('/');
  pathArray[1] = language;
  search = (0, _extractFilterFromURL.default)(search, props).map(function (filter) {
    var key = filter.key,
        value = filter.value,
        foreignKey = filter.foreignKey,
        localize = filter.localize;
    if (!localize) return filter;

    if (key === 'project') {
      var t = props.t;
      filter.value = props.activeFilter.project.map(function (filter) {
        return t("".concat(filter.value, "-filter"));
      });
      return filter;
    }

    var foreignFilters = props[foreignKey];
    if (!foreignFilters) return filter;
    var newLanguageFilters = foreignFilters[language];
    if (!newLanguageFilters) return filter;

    if (key === 'products') {
      key = 'product';
    }

    var oldValues = props[key].filter(function (oldValue) {
      return value.split(',').indexOf(oldValue.value) !== -1;
    });
    var newValue = newLanguageFilters.filter(function (newValue) {
      return oldValues.find(function (oldValue) {
        return oldValue.id === newValue.id;
      });
    }).map(function (item) {
      return item.value;
    });
    filter.value = newValue;
    return filter;
  }).map(function (filter) {
    // splitting is done in advance, when translating the values
    if (filter.value instanceof Array) {
      return "".concat(filter.key, "=").concat(filter.value.map(function (x) {
        return encodeURIComponent(x);
      }).join(','));
    } // try to split now, because we do not want to encode the comma


    if (filter.value.split(',') instanceof Array) {
      return "".concat(filter.key, "=").concat(filter.value.split(',').map(function (x) {
        return encodeURIComponent(x);
      }).join(','));
    }

    return "".concat(filter.key, "=").concat(encodeURIComponent(filter.value));
  }).join('&');
  return "".concat(pathArray.join('/')).concat(search.length > 0 ? '?' + search : '');
}

var _default = translateUrl;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/footer/translateUrl.js
// module id = 279
// module chunks = 0